import React from 'react';

const CheckIndicator = () => {
  return (
    <svg width="16px" height="16px" className="uni-form__check-indicator" viewBox="0 0 16 16">
      <rect className="uni-form__check-indicator__background" x="2" y="2" width="12" height="12" rx="2" />
      <rect className="uni-form__check-indicator__indeterminate" x="5" y="7" width="6" height="2" rx="0.5" />
      <path
        className="uni-form__check-indicator__check"
        d="M11.3756706,4.23018776 L6.43160893,10.1230579 L4.46475452,8.47354152 C4.1980624,8.24916113
        3.79097226,8.28249764 3.56338643,8.55303629 L3.1511676,9.04539098 C2.92165851,9.31913506 2.95820046,9.71981433
        3.2287391,9.94675907 L6.17837963,12.4219953 C6.31172569,12.5335444 6.48033153,12.581626 6.64444976,12.5675221
        L6.64573193,12.5688042 C6.80920908,12.5540592 6.96691644,12.4764877 7.08038881,12.3412184
        L12.8488882,5.46620318 C13.0783972,5.19374127 13.0418553,4.79049765 12.7706756,4.56355291 L12.278962,4.1500519
        C12.0052179,3.9211839 11.6032564,3.95900803 11.3756706,4.23018776 Z"
      />
    </svg>
  );
};

export default CheckIndicator;



// WEBPACK FOOTER //
// ./src/forms/__partials/check-indicator.jsx